<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>关卡数值配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:levelCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:levelCfg:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>
          </el-row>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="关卡">
              <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="关卡" />
            </el-form-item>
            <el-form-item label="体力奖励">
              <el-input v-model.number="item.physical_reward" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item label="金币奖励">
              <el-input v-model.number="item.conis_reward" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item label="iconID">
              <el-input v-model.number="item.iconId" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item>
              <el-button v-if="item.levelId === 0" v-permisaction="['config:buildCfg:add']" type="primary" @click="del(index, item.levelId)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:levelCfg:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:levelCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { exportLevelCfg, importLevelCfg, getLevelCfgList, updateLevelCfg } from '@/api/config/level-cfg'
export default {
  name: 'LevelConfig',
  data() {
    return {
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'levelId': 0,
          'iconId': 0,
          'physical_reward': 0,
          'conis_reward': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateLevelCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getLevelCfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'iconId': 0,
        'physical_reward': 0,
        'conis_reward': 0
      })
    },
    del(key, id) {
      this.formData = this.formData.filter((item, index) => {
        return index !== key
      })
    },
    exportData() {
      exportLevelCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      importLevelCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importMoneyUploadSuccess(response, file, fileList) {
      // importSlotWeightCfg({ path: response.data.path, ImportType: 2 }).then(res => {
      //   // eslint-disable-next-line eqeqeq
      //   if (res.code === 200) {
      //     this.msgSuccess(res.msg)
      //     this.getTables()
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    }
  }
}
</script>

<style scoped>
</style>
